module.exports = __webpack_public_path__ + "img/img_about03.68192396.jpg";